import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";

const Track11DRed = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED);
	return (
		<g id="Track11DRed" transform="translate(2146.000000, 608.000000)" className="track">
			<path
				d="M0.281728647,0.333732633 C38.1187033,15.8158682 56.8938247,33.6289228 63.9142647,56.6590143 C66.4245642,64.8938868 73.1198093,84.340882 84,115"
				id="Stroke-1" stroke={trackColor}
				strokeWidth={tracksWidth} strokeLinecap="round"/>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track11DRed')}
				coords="45.616760, 38.000000"
				text="11D"
				textCoordsX="7.86669922"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			/>
		</g>
	);
};

Track11DRed.propTypes = trackPropTypes;

export default Track11DRed;
